import Page from '../../../../page/Page';
import { ArrowBack } from '@mui/icons-material';
import Box from '@mui/material/Box';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button, Card, Divider, Grid, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../stores/types';
import CartItemCard from './components/CartItemCard';
import _ from 'lodash';
import Header from '../../../../components/header/Header';
import { useTransform } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import ProductCard from '../../../../components/productCard/ProductCard';
import { useSnackbar } from 'notistack';
import { StoreArticle } from '../../../../components/types/storeCard';
import {
  addToCartEffect,
  addToWishlistEffect,
  removeFromCartEffect,
  removeFromWishlistEffect
} from '../../../../../stores/effects/storeArticles';
import { useEffect } from 'react';

export interface Product {
  id: string;
  name: string;
  category: string;
  price: string;
  rate: number;
  image: string;
}

const productsList: Product[] = [
  {
    id: '1',
    name: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore ipsa veritatis voluptatem vero, saepe exercitationem perspiciatis. Voluptatem architecto cupiditate non quae nostrum numquam eum suscipit, voluptates vitae tempore error recusandae?',
    category: 'Logiciel Microsoft',
    rate: 4.5,
    image:
      'https://www.codesproduit.fr/wp-content/uploads/2021/10/office-2021-professional-plus-pc-300x400.jpg',
    price: '10.000 XAF'
  },
  {
    id: '2',
    name: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore ipsa veritatis voluptatem vero, saepe exercitationem perspiciatis. Voluptatem architecto cupiditate non quae nostrum numquam eum suscipit, voluptates vitae tempore error recusandae?',
    category: 'Logiciel Microsoft',
    rate: 4.5,
    image:
      'https://www.codesproduit.fr/wp-content/uploads/2021/10/office-2021-professional-plus-pc-300x400.jpg',
    price: '10.000 XAF'
  },
  {
    id: '3',
    name: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore ipsa veritatis voluptatem vero, saepe exercitationem perspiciatis. Voluptatem architecto cupiditate non quae nostrum numquam eum suscipit, voluptates vitae tempore error recusandae?',
    category: 'Logiciel Microsoft',
    rate: 4.5,
    image:
      'https://www.codesproduit.fr/wp-content/uploads/2021/10/office-2021-professional-plus-pc-300x400.jpg',
    price: '10.000 XAF'
  },
  {
    id: '4',
    name: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore ipsa veritatis voluptatem vero, saepe exercitationem perspiciatis. Voluptatem architecto cupiditate non quae nostrum numquam eum suscipit, voluptates vitae tempore error recusandae?',
    category: 'Logiciel Microsoft',
    rate: 4.5,
    image:
      'https://www.codesproduit.fr/wp-content/uploads/2021/10/office-2021-professional-plus-pc-300x400.jpg',
    price: '10.000 XAF'
  }
];

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
}

function CartPage(props: Props) {
  const { store } = useParams();
  const { cart, articles } = useSelector(
    (state: ApplicationState) => state.shop
  );
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { enqueueSnackbar } = useSnackbar();

  const handleAddToCart = (article: StoreArticle, remove: boolean) => {
    if (remove) {
      // Remove from cart
      dispatch(removeFromCartEffect({ ...article }, enqueueSnackbar));
    } else {
      dispatch(addToCartEffect({ ...article }, enqueueSnackbar));
    }
  };
  const handleAddToWishlist = (article: StoreArticle, remove: boolean) => {
    if (remove) {
      dispatch(removeFromWishlistEffect({ ...article }, enqueueSnackbar));
    } else {
      dispatch(addToWishlistEffect({ ...article }, enqueueSnackbar));
    }
  };

  const handleNavigate = (url: string) => {
    navigate(url);
  };

  // to add the scroll propeties
  useEffect(() => {
    const html = document.querySelector('html')!;
    if (location.pathname === '/ova-store/store/equipments/cart') {
      console.log('executed... ', location);
      html.style.overflowY = 'scroll';
    } else {
      if (html) html.style.overflowY = 'auto';
    }
  }, [location]);

  return (
    <Page title="OVA consulting | store cart">
      <Header />
      <section className="training-page main homepage">
        <section
          className="banner"
          style={{ backgroundImage: 'url(/assets/expertises/training-1.png)' }}>
          <div className="banner-content" style={{ padding: '100px 0px' }}>
            <div className="container mt-3">
              <Link to={`/ova-store/store/${store}`} className="goback-button">
                {' '}
                <span>
                  <ArrowBack color="primary" />
                </span>{' '}
                GO BACK
              </Link>
              {/* <Grid sx={{ p: 3 }} className="d-flex">
                <Button
                  onClick={() => handleNavigate()}
                  startIcon={<ArrowBack color="primary" />}
                  variant="outlined">
                  
                </Button>
              </Grid> */}
            </div>
            <div className="container mt-3">
              <p className="title">{t('Cart')}</p>
              <p className="text">
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Expedita quas, nemo totam illum pariatur iste obcaecati
                asperiores, architecto fugit corporis nihil deleniti incidunt
                eum placeat in natus. Iure, dolorum fugiat!
              </p>
            </div>
          </div>
        </section>
      </section>
      <section className="store-main">
        <div className="container">
          {/* <Box sx={{ display: 'flex' }}>
            {/* <ShopDrawer isCart={true}/> *
            <Box component="main" sx={{ p: 3 }}>
              <Grid container spacing={5}>
                <Grid item md={8} sm={7} xs={12}>
                  <Grid>
                    <Grid container spacing={4}>
                      {cart.map((article) => {
                        return (
                          <Grid item md={12} xs={12} key={article.id + 'cart'}>
                            <CartItemCard product={article} />
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item md={4} sm={5} xs={12}>
                  <Grid>
                    <Card sx={{ p: 3 }}>
                      <Box>
                        <Typography variant="h6">
                          Total: $ {_.sumBy(cart, (item) => item.price)}
                        </Typography>
                        <br />
                        <Divider />
                        <Box sx={{ marginTop: '1rem' }}>
                          <Button
                            onClick={() =>
                              handleNavigate(
                                `/ova-store/store/${store}/checkout`
                              )
                            }
                            variant="outlined">
                            CHECKOUT
                          </Button>
                        </Box>
                      </Box>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box> */}
        </div>
        <section className="container cart">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-12">
                <div>
                  <h4>PANIER (2 PRODUITS)</h4>
                  <div className="cards">
                    <div className="card">
                      <div className="row">
                        <div className="col-md-3 col-12">
                          <div className="image">
                            <img
                              width={'100%'}
                              src="data:image/jpeg;base64,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"
                              alt=""
                            />
                          </div>
                          <div className="text">
                            <p> Garantie 2 ans </p>
                          </div>
                        </div>
                        <div className="col-md-7 col-12">
                          <div className="cart-item">
                            <div className="title">
                              PC Portable Lenovo Ideapad 3 15ALC6 15.6" AMD
                              Ryzen 7 8 Go RAM 256 Go SSD Gris
                            </div>
                            <div className="category">Category</div>
                            <div className="in-stock-or-not">
                              <span>&#10004;</span> In stock
                            </div>
                          </div>
                        </div>
                        <div className="col-md-2 col-12">
                          <div className="card-count">
                            <div className="price">10.000 XAF</div>
                            <div className="quantities">
                              <input defaultValue={1} type="number" />
                            </div>
                            <div className="actions">
                              <button className="btn">Supprimer</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="row">
                        <div className="col-md-3 col-12">
                          <div className="image">
                            <img
                              width={'100%'}
                              src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoHCBISEhgSFRUZGBQYEhkaGRoaGB4aGBgYGhgZHBgYHB8cIy4lHB8rHxoaJjgnKy8xNjU1GiQ7QDszPy40NTQBDAwMEA8QHxISHzQrJSsxPz09Njc9PzQ2NDQ0OD83PT81PzQ0NzY0Pz00NDQ0MT02Oj00PzQ0NDQxMTU0NDQ0NP/AABEIAL0BCgMBIgACEQEDEQH/xAAcAAEAAQUBAQAAAAAAAAAAAAAABgIDBAUHAQj/xABKEAACAQIDBAcDCAUICwEAAAABAgADEQQSIQUxQVEGImFxgZGhEzJSB3KSorHB0fAzQmKCshQVQ1PC0uHxIyREVGNkc4OTo7NF/8QAGQEBAAMBAQAAAAAAAAAAAAAAAAEDBAIF/8QAJxEBAQABAwQBBAIDAAAAAAAAAAECAxEhBBIxUUEFEyIygfBhccH/2gAMAwEAAhEDEQA/AOzREQEREBERAREQEREBERAREQEREBERAREoZgBcmw7YFcTVYzpDgqP6TFUEPJqqA+RN5p8V8ouyqf8AtOc/8NHceaqR6wJbEgFX5WNmqLqK7n4RTsfNiB6zTYz5Z6S/o8I55Z6ip/CGgdXicWq/KttKr+gwaAfMq1j9XKJi1OlHSSt7oamDwFKmn/1uRJkt8ItkdzlurVVRdmCjmSAPWcEq4Pb9f9Jiqi9hxBUeVIWmDiuhFbI9WtiVYpTZjo7k5VLWuxHKT2Zekd+Pt9FJUVgCCCDuINwfES5OffIupGzLkmxrvYcAAqDTxvOgzl0REQEREBERAREQEREBERAREQEREDyYOP2rh8MAa9anTzXtnYLe2+wJ18JnTmXSzCU8VtN1e5WlhqK2Bt1mao59CJOOPddojLKYzepLiOnuzaentyx/Yp1GHmFy+s1WJ+VHCL7lGs/bZFX1a/pNNR2BhV/ogfnMzfxEiZ+H2fRT3aaL3IoPmBLfs35qr70+Ix6nyoVnNqODB7TUZj9FU++Yz9MNt1fcw6oOH+hYHzqPb0m/RZeRJP2p7R92+kJeht2uOviKi3/4y0//AIbpjv0HxVYf6bEqfnM9U/XtOhqkoxFRUXMx/E906x0pbtOXOWrZN7whFP5Paf69dtSdERUAvyBzADstMun0EwajrCo/znt/AFmVjtsO2iCw4b9e62regmpetXvmuR23C/Zr6zfp/TrZvbIxZdfzxu29LorgUFhh0Pz7v/GTM2jgaVP3KaJ81FX7BNbsjbZZxSq72NkfTU/Cbadxm9ZZn1dC6OW1i/DUmeO8qw0oIl5hKCJwnZaIms6RNlweIP8Ay9QeaEffNqRNH0yfLgK55oq/SdF++RleKnGcxLvkno5NlUv2mqN9cj7pM5Gfk7p5dl4Yc6Zb6TMfvkmmNtIiICIiAiIgIiICIiAiIgIiICIiB5OaO2fH46p/zFNB/wBuiin1JnS5y/YzZ/b1PjxuIcd3tGVfRZZpfsr1f1bBVl5FlKrMhFmi1nkeokyUSYuKxSUlzNv4DifwHbPej1ZcYtRqi3QOqqutrZQ2oG/RgdZ19vKY3O+HPfO7tnn++XmL2hTproQzcADe3fbd+e+R/FVs5z1WAvuBI+z7v85O6WAoLa1BR+6tx5iZCCmNyW8h9k60+ow0/GPPtXq9Lnq3nKSenNLs/wCjUsexWN/EXmHW2fjagDJQq3zWKlCumvWBa24j1E60av7A8WP4Sn2t72C8jpe3rNE+o5TxjP55c4/TsZ5u7iu0aT02yuClQKSw0urKFYHTjZhJ7g63tKSVOL01Y9hKgkec590s2gHxuJa/VR2pjtIJDfY30ROg7Mw5p4elTb3lpIG+cFGb1vLOs1Jnp4ZXynR0+zKz4VMJQwl5xLbCeev2WiJGenrWwLj4qlMfXU/dJQRIh8o7f6oi/FiUHkjn7QJGV/Gpwn5R1fonSyYDDLyw1P1UGbiYmy6eWhSX4aSDyUCZcyNZERAREQEREBERAREQEREBERAREQLVeqEVmO5VJPgLzmPRVD/I6JO9qec97sz/ANqTnpdifZ7PxVTiuFq278jAepEiuy6Ps6FJPhpIvkgBlul5qrV8RmIsYrErSTOdTuUc2toOwS4izUbd2milaWh64DMeBOgUduuvLv3a9HDvzk24+WXWy7cLZ5aatiqlWpY3Fxq2hW2m4Hw0kx6L4T2OEfKCxeqzWJI3hVIW2oHVJt368ZG6mIp0lzWGa3LWSXY9UvgqJLmmXe4IbKxJqsVQaG+YC3cZs667aUkm03Yuh3y1Lf8ADdsXFRVUL7PK2YktmBFsgGliN97m+glvNVKvuDXOTS9hbqlgWFyDqdRKKdRGxDKKhLrRXNTv1VDMSr2tvNiN+4S3VamtFi73RnN2ysb53tlGU3tmawtuHnPJ4exvt5ZGWpZOsAQVz9Uday9YDXq3PK8uKbuRmvoOrcadpFri/aeEw8TiKYr0qTXNUq7JZdAFFnJPDQ2l5WQNUbW65S1wct1UEZbjXS17RLumzmX24vsjBHG7TcWvSXE1arngV9qTr85sq25XPOdUcTh2y+kGJooy0Xye0bM7KozubaAsQSANbBbe8ZtsF0pxdMg+3d9dQ5zqezrX9J6N0ctXxZwy5ZTH4dVcS0wms2Dt+njFItlqKLsvAjdmXmL8OF/GbVhMuWOWGXblOUyyzeLREhvyg9b+S0/jxP2KF/tyaGQ7pYntMfs+nzrE/wDsoj7jK8/1rvCflHakWwA5ACVxEzNJERAREQEREBERAREQEREBERAREQIr8pLkbNqqN9R6NMfv1kU+hMwlW0vfKK96eFp/HtGjf5qB6h/gEtoJdpeKp1PMXUEieOpZazra5ViQSBop1DXO7Q75KK+IWmhdtw9ZANvbXesxJ0XgByG6/Pf4XnrfT9PPLK34eb1tlkx35/4tbUxuHUHOzMeS2A82BJ8hOn7GpIMJhgVJC0abKCpYhsgIJyjeLzh4wL4gsF4D14Cd4OFsaYDVAKdNlyobI/VVRn4ki1xy1j6ndpjj8cruhwxx32vPyyqaKbuAQWGt8ynluNiJ7kFra27ST6kzyitr+/8AvNfy1NpRXW5XRjYk6GwvlI62uo13a62PCeS3r2UXvbXnNft2qKeDxFQCxXC1X4A3FNiLkcdBMinS3dQd5Ov2TWdNKxp7OxDDU+xKi+67kKP4oxm+UhbtHA6OAqMoCiwtqbb/AMB9sNhKlPU6rfeNw7+Uz12fWqi7knsOgHcNw8pqXpGlVIGmmo+0HmJ7OWN09rsx45zO2bxJejuIanXpOP6xQe1WIVh5EzqrCcu6LYb2uJpIBoHDt2IhDepCr+9OptM/W5S5Tb0jSlku/tZMie0Ovt3AU/hAbzdz/YkuMi+ETP0koD4KAP1ap/tTz9T9WnT/AGdiiIlC8iIgIiICIiAiIgIiICIiAiIgIiIEH6cPmxuApcA2Jqn9yllX1qS4gmu6V7UwtLbFP+U1fZomznIOVj16lYADqqf1aZla9Kdj/wC+fUf+5LcMpIryxtq30lpsaQYe6p63YDbXwI9Zz7aqFdZ0g9KdjkEHFqQRYgo9iDvB6kjtddhMCv8ALmym9h8IPAXpXt33nq9H1+npYXHJ5+t0mWWpM8f5aDotiCrKFALPiKdPXcA5AJ8AD427p2Z3RmK57OEBKh7EKWNmy8LkEX7JzLA4bYlFg6bRcMrq6klTZkuVNjRsd/Gb2n0h2cGLnal2IALFKGYgXsCRQ3C58zM/Wa+GtlLj8e2nR0rp73bymiIF3Em/M3lFSmrEEk6X0BIBzCxuBo3jukOHSnCD/wDU0vb+g0GewP6D4etbwlK9KMLx2p64f4rf1PLrekycbeYvlvwmaU1XUTRdO8SqYByVzAvTFr2v11O/wmrpdI8IR1trkanT/Vjpc219gN418Za2jtLZuJp+zqbUDLmBtmoLqL2PVpjnO9K445zLK8SudSXLGyTzHNdpbdrghaYVSTpZQzeJa49BLVPB1MRWVEUvWYXbKACQLAFraKBzNuHZJi2wthFs52kS1rX9rR08PZ2kj2FV2Jg6fs6eNpksxZnaqhdySbZiAL2GgHDzmzV63G22c+t/hTh0/bJJJP8AXyo6NbAXB0zchqz2LsN2m5Fv+qPU68gNu0pO3NlH/bqP/lSUNtnZXDHUT/30Ex5andd7VnZZwqMjPRcZuklU8Ew9v/VT+9jN+22tm8MXROv+80t1hzHf5TTfJ+1OrtvHVabh6YSyuCGDL1FBBGhHVlWeUs2jvDGy8usxESpaREQEREBERAREQEREBERAREQExsXikpIXc2UfkAczLtWoqqXYgKBck8BOd9Jtt+1JY6U19xeJPM9p9B43CN9NsB/OGLOJVii+zVArAE9Qsb6HS+bdIpW6OsrFfaC433VgNeRAN5v22i5YkOQAbnqA+Gp5+nbrKBtGpYtn7AMi+JH55+AR89H2/rE+t/dlB2C/9Yn0v8JIXx9TKOsLn9kX38hv0tyv9nr4581rpbXge227d2+MCNnYVT40+n/hKTsGp8afTEkn8tbUHJ6+Otu7zlK4ongpOp0B3cN/n/lAjh2DV+JPpiUnYFb9n6Q/GSI4kkaKpta54a+vPynvt1J9xct9Tcfnl5wI2dgV+Q+kPxlB2BX+EeY/GSUVlOpRbWPEXuLaesqD09+QZdNdL9osOXfygRc7BxHweo/GUnYWI+D1H4yVK6WuUA1A58Lk7u7znqslr5CNbel76DwgRI7ExHweo/GBsLEH9QfSEl6slgcpGtuJ3cdPzpLwqLlL2IAv3ntHjp4QIWdgYn4PrL+M6X8heFKtiXItYJTItYhlJLDXvHkZqcPVFQaAjvnVOhmw0wlDMARUrEVHvwJGi9lgfMmBJIiICIiAiIgIiICIiAiIgIiICUk21O6VSKdIdrXvSRrKPfa+htvF/hHH83DB6SbZFS6qbUV4/EefdyH5EDx+KaoxsVy206y2tvsQ3bby7rZO1doB2KcAd1yrX57vt/GapmU785/fF+73IHpDBdyG9yPc0N7Hx09ByMMj6JkBYWF7Llt4C1p6wS4HWty0IGm7kQLeIEpCKW98k20OUWHaet4d5gUkMWvkOg1up8dNw7pSDqWyG3EnNe57b8x+bz1UBuQ3W7Rpbv11+4HthFOUlWB+L3tBw3j86QLauACctgdL3N+7U8j6iUqVy8r7rHfz/PfL3XC6NccTm3Hlrb8mePnygXzDnmB1sLjU935MC0SuS1jv5i57b205eHZBy5Rw9Se3dLlQPYDLe3GwN+wdk8rBtBluQLXy7+VtN0ChwuUa27LXJ7d/O/5tPHUZQbkDda2p5nfuvf8ANpVXNrAqLgWOlvDT87oruBYEC4GupAHZv5WF+yB44GUWNh26X3XO/UX/ADpPGQZRYiw5g6tx79Lek9qsLBbaga2J05DXjaUMc1gLAAbiR2m+sC7STOcoCeGe9uJHCbUC2g3AW8JjYChlQMfeb0X9UDv3+I5TJqPlBO/s4k8AO0nTxgbXongTisaKZW9OmgqVDwHWtTp9uaz37FnXpoOiWyDhcMof9K9mqG36xGi9yjTzm/gIiICIiAiIgIiICIiAiIgIiara+0fZjIp65HkOffAxtubTyg0kPW/WI4DkO3890E2u9RhlRSVvrbQn/D8O6bt5aYQIcUrDUh7bgLk8N9tdPz30U2ZPfzAFSRZAWvw37iT5DhrpLnUSxUVRqRAiDOV6uVc5NiMig62svn+dJQ7gCwVTzPW3i/G+7X75KGUfCPOYz4Wmd6L5D74EcZxa2W2t9CfvvPGdSALEW/aGvbu3/gJvHwFM/qW7v8DLL7Op8Lj6X3wNSzKdBmAt2Hx4cZ6bN1VYhbbiNNNbmx11+2bB9mp8Z8x+E8/m2w6rakjXsHDSBr3UNorC1txuNwJJ3W5w63IVSCOGtjxPHxJmX/N7AGzdYnfbhy48dfCUfyFwDuzH7OPDQwLDltFVrgbiGFyfO/GKmcKBqTvJ3kfsy6mFe9yvujqjTUjdewF+89ktmg5axzWuRdlX3bk8zY6ndfUwLLO53gnvX8RLuFph2GgIGrXUAd3n9/KeVM1ySp3WUC+ltxFt82WFplUAJJJ1PZfh4aeN4F2b3oXsgYnEiowvToMG7Gqa5B221bwXnNCVZiEQEu7BVA3kk2AnXej+y1wuHSiNWAu5+Jj7x7uA7AIG0ieRA9ieRA9ieT2AiIgIiICIiAiJjY3FCkmY6ncBzMCztLHikumrn3R957JFajliWJuSbky7Xqs7FmNyfzaWWgUNLTS60tNAtNMJ2zHs4dvbL2Ie/V8/wlgwKGltpcaW2gWzKGlZlLQLZEESu0pMCgykyszyBQZ4RPTPDApKiJ6ZVh8K9aolFPfdrX4Ku9mPYBcwJL0A2T7So2LYdRLpSvxbc7+A0HeeU6HeYGAw6UaSUkFlRQo8OJ7SdT2mZQeBdvF5bDSoGBXEpE9ED2VSmVQEREBERAREQExsZhKdZcrrmG/iCDzBGoPdMmIGjfo3R/UaqndULelTMJi1OjdQe5iAf+pSDHzRk+ySaIEPq7Exa7hScdjsh8ihH1ph1cFiV97D1Lc1yOPJGLeknkQOY1yiaurJ/wBRHp/xgS2uRtVYMOwgj0nUpg4nZWGqavRpuebIpPna8DnDJLTIZPavRbCNuRlP7NRwPo3y+kwa3Qxf1K9QfPVWHoFPrAhbAykCSet0PxI92pTfvDU/7819fo7jE/oc3ajoR9YqfSBqDKDMmvhKtP36NRe003y/SAt6zE9op0DC/K4vA8M8MrMoMCkykyoyqiVzAvcqDqBx7O4mBlJTKKqZipfr1GBsUpKL5dNxbvB1Gh1m+6KJq+Lcderog+CmDp9KwPcBzkcquKjso31ageprfKigBUByqSCQeGmm+0k+BDNaw09BOcfabJLwkiYgGZKPea/DYczY06U6QvLKwJSqS4FgAJ7E9geSqIgIiICIiAiIgIiICIiAiIgIiICIiAiIgJj18JTqCzorj9pQ32iZEQNLW6LYJv6BV+YTT/gImvrdCMOfdqVU7MysPrKT6yVRAglboLUHuV1bsdCvqrH7JrcR0Qxq7kpv82pb+NROmxAg2w+hzr165UMd6qbgchfj/nJXQ2ciCwEzogW1pASoLKogeWiexAREQEREBERA/9k="
                              alt=""
                            />
                          </div>
                          <div className="text">
                            <p> Garantie 2 ans </p>
                          </div>
                        </div>
                        <div className="col-md-7 col-12">
                          <div className="cart-item">
                            <div className="title">
                              PC Portable Lenovo Ideapad 3 15ALC6 15.6" AMD
                              Ryzen 7 8 Go RAM 256 Go SSD Gris
                            </div>
                            <div className="category">Category</div>
                            <div className="in-stock-or-not">
                              <span>&#10004;</span> In stock
                            </div>
                          </div>
                        </div>
                        <div className="col-md-2 col-12">
                          <div className="card-count">
                            <div className="price">10.000 XAF</div>
                            <div className="quantities">
                              <input defaultValue={1} type="number" />
                            </div>
                            <div className="actions">
                              <button className="btn">Supprimer</button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="cart-footer">
                        <div className="row">
                          <div className="col-md-8">
                            <div>
                              <div className="title">
                                Garantie reparation pendant 3 ans
                              </div>
                              <div className="extra-price">
                                189<sup>99</sup> soit 189<sup>20</sup> /mois
                              </div>
                              <div className="link">
                                <Link to="#">En savoir plus</Link>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div>
                              <button className="btn add-service">
                                <span>+</span> Ajouter ce service
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{ backgroundColor: 'translate', padding: '1rem' }}>
                    <p className="text-grey mb-0">
                      ET SI VOUS CRAQUIEZ AUSSI POUR ...?
                    </p>
                  </div>
                  <div className="more-items">
                    <div className="row">
                      {articles?.results?.map((product, index) => {
                        return (
                          <div className="col-md-4 col-sm-6 col-12">
                            <ProductCard
                              handleAddToWishlist={handleAddToWishlist}
                              handleAddToCart={handleAddToCart}
                              product={product}
                              key={product.id}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-12">
                <div>
                  <h4>RECAPITULATIF</h4>
                  <div className="cards bg-transparent">
                    <div className="card border-none">
                      <p>
                        <strong>Un code promo ?</strong>
                      </p>
                      <form className="form-inline">
                        <div className="form-group mr-2 mb-2">
                          <input
                            type="text"
                            className="form-control"
                            id="inputPassword2"
                            placeholder="Ecrivez le ici"
                          />
                        </div>
                        <button type="submit" className="btn btn-primary mb-2">
                          Validate
                        </button>
                      </form>
                    </div>
                    <div className="card border-none mt-2">
                      <p>
                        <strong>Un code promo ?</strong>
                      </p>
                      <table className="table borderless">
                        <tbody>
                          <tr>
                            <td style={{ borderTop: 'none' }}>
                              <p>
                                Panier <span style={{ opacity: 0.5 }}>(2)</span>
                              </p>
                            </td>
                            <td style={{ borderTop: 'none' }}>
                              <p>
                                958<sup>95</sup>
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ borderTop: '0px' }}>
                              <p>Frais de livraison estimes</p>
                            </td>
                            <td style={{ borderTop: 'none' }}>
                              <p>Gratuit</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>
                                <strong>TOTAL</strong>{' '}
                                <span style={{ opacity: 0.5 }}>
                                  (TVA incluse)
                                </span>
                              </p>
                            </td>
                            <td>
                              <h6 className="text-primary">
                                968 <sup className="text-primary">99</sup>
                              </h6>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={2} style={{ borderTop: '0px' }}>
                              <button
                                style={{ width: '100%' }}
                                className="btn btn-primary">
                                Valider mon panier
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="card border-none mt-2">
                      <div className="checkout-order">
                        <div className="image">
                          <img src="/assets/img/orderpipe.svg" alt="" />
                        </div>
                        <div className="text">
                          Réglez votre commande en{' '}
                          <strong>plusieurs fois</strong> avec notre partenaire
                        </div>
                      </div>
                      <div>
                        <p className="mt-3 mb-2">
                          <strong>Nous acceptons</strong>
                        </p>
                        <div className="row">
                          <div className="col-3 mb-3">
                            <div
                              className="border d-flex"
                              style={{
                                borderRadius: '4px',
                                overflow: 'hidden',
                                height: '40px',
                                opacity: 0.5
                              }}>
                              <img
                                width={'100%'}
                                src="/assets/img/visa.jpeg"
                                alt=""
                                className="m-auto"
                                style={{ filter: 'grayscale(1)' }}
                              />
                            </div>
                          </div>
                          <div className="col-3 mb-3">
                            <div
                              className="border d-flex"
                              style={{
                                borderRadius: '4px',
                                overflow: 'hidden',
                                height: '40px',
                                opacity: 0.5
                              }}>
                              <img
                                width={'100%'}
                                src="/assets/img/visa.jpeg"
                                alt=""
                                className="m-auto"
                                style={{ filter: 'grayscale(1)' }}
                              />
                            </div>
                          </div>
                          <div className="col-3 mb-3">
                            <div
                              className="border d-flex"
                              style={{
                                borderRadius: '4px',
                                overflow: 'hidden',
                                height: '40px',
                                opacity: 0.5
                              }}>
                              <img
                                width={'100%'}
                                src="/assets/img/visa.jpeg"
                                alt=""
                                className="m-auto"
                                style={{ filter: 'grayscale(1)' }}
                              />
                            </div>
                          </div>
                          <div className="col-3 mb-3">
                            <div
                              className="border d-flex"
                              style={{
                                borderRadius: '4px',
                                overflow: 'hidden',
                                height: '40px',
                                opacity: 0.5
                              }}>
                              <img
                                width={'100%'}
                                src="/assets/img/visa.jpeg"
                                alt=""
                                className="m-auto"
                                style={{ filter: 'grayscale(1)' }}
                              />
                            </div>
                          </div>
                          <div className="col-3 mb-3">
                            <div
                              className="border d-flex"
                              style={{
                                borderRadius: '4px',
                                overflow: 'hidden',
                                height: '40px',
                                opacity: 0.5
                              }}>
                              <img
                                width={'100%'}
                                src="/assets/img/visa.jpeg"
                                alt=""
                                className="m-auto"
                                style={{ filter: 'grayscale(1)' }}
                              />
                            </div>
                          </div>
                        </div>
                        <p style={{ opacity: 0.5 }} className="text-center">
                          <img
                            width={'30px'}
                            src="/assets/img/securepayment.png"
                            alt=""
                          />
                          <strong>Paiement 100% securise</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </Page>
  );
}

export default CartPage;
